<template>
    <v-dialog v-model="dialog" width="700px">
        <v-card>
            <v-row no-gutters>
                <v-col></v-col>
                <v-col cols="10"></v-col>
                <v-col><v-btn icon @click="delHsiiDetails()"><v-icon color="red" small>mdi-trash-can-outline</v-icon></v-btn></v-col>
            </v-row>
            <v-card-title class="pt-0 justify-center">{{ hsii.titel2 }} </v-card-title>
            <v-card-subtitle class="text-center">{{ hsii.titel3 }}</v-card-subtitle>
            <v-divider/>
            <v-row no-gutters class="ma-2" v-for="item in hsii.props" :key="item.group">
                <v-col cols="1"></v-col>
                <v-col :cols="item.multiple?'8':'1'" class="ma-2"  >
                    <v-autocomplete v-model="item.selected_choices" return-object :items="item.group_choices" item-text="indd_oms" item-value="indd_nr" dense :multiple="item.multiple" :label="item.group"/>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn class="primary mx-2" small @click="cpyHsiiDetails">Copy</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="updHsiiDetails">Save</v-btn>
                <v-btn color="primary" small @click="closeDialog(hsii_encrid)">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>    
    export default {
        data() { 
            return {
                dialog: false,
                huis_encrid: "",
                hsii_encrid: "",
                hsii: {
                    titel: "",
                    props: [],
                },
            }
        },
        mounted() {
        },
        methods: {
            openDialog(huis_encrid, hsii_encrid) {
                this.huis_encrid = huis_encrid;
                this.hsii_encrid = hsii_encrid;
                this.getHsiiDetails(huis_encrid, hsii_encrid);
            },
            getHsiiDetails(huis_encrid, hsii_encrid) {
                this.$axios.post("ares/json/ares/huis/hsii/getHsiiDetails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsiiDetails"
                    },
                    getHsiiDetails: {
                        huis_encrid: huis_encrid,
                        hsii_encrid: hsii_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {
                        this.hsii = res.data.getHsiiDetails;
                        this.dialog = true;
                    }
                });
            },
            updHsiiDetails() { 
                this.$axios.post("ares/json/ares/huis/hsii/updHsiiDetails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHsiiDetails"
                    },
                    updHsiiDetails: {
                        huis_encrid: this.huis_encrid,
                        hsii_encrid: this.hsii_encrid,
                        props_array: this.hsii.props,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {     
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.updHsiiDetails.text,
                            color: res.data.updHsiiDetails.color
                        }); 
                        this.closeDialog();
                    }
                });
            },
            cpyHsiiDetails() { 
                this.$axios.post("ares/json/ares/huis/hsii/cpyHsiiDetails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "cpyHsiiDetails"
                    },
                    cpyHsiiDetails: {
                        huis_encrid: this.huis_encrid,
                        hsii_encrid: this.hsii_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {     
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.cpyHsiiDetails.text,
                            color: res.data.cpyHsiiDetails.color
                        }); 
                        this.closeDialog();
                    }
                });
            },
            delHsiiDetails() { 
                this.$axios.post("ares/json/ares/huis/hsii/delHsiiDetails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "delHsiiDetails"
                    },
                    delHsiiDetails: {
                        huis_encrid: this.huis_encrid,
                        hsii_encrid: this.hsii_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {     
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.delHsiiDetails.text,
                            color: res.data.delHsiiDetails.color
                        }); 
                        if (res.data.delHsiiDetails.color !== "error") {
                            this.$emit("selectItemById", "x", "x");
                        }
                        this.closeDialog();
                    }
                });
            },
            closeDialog() {
                this.$emit("refreshLayout");      
                this.dialog = false;
            },
        }
    }
</script>
